import { ChakraComponent } from '@chakra-ui/react'

import { BasicField } from '~shared/types/field'

import i18n from '~/i18n/i18n'

import { VerifiableFieldType } from '~features/verifiable-fields/types'

import { EmailOtpSvgr } from './EmailOtpSvgr'
import { MobileOtpSvgr } from './MobileOtpSvgr'

type VerificationBoxRenderData = {
  logo: ChakraComponent<(props: React.SVGProps<SVGSVGElement>) => JSX.Element>
  header: string
  subheader: string
}

export const VFN_RENDER_DATA: Record<
  VerifiableFieldType,
  VerificationBoxRenderData
> = {
  [BasicField.Mobile]: {
    logo: MobileOtpSvgr,
    header: i18n.t<string>(
      'features.verifiableFields.components.VerificationBox.constants.verifyMobile',
    ),
    subheader: i18n.t<string>(
      'features.verifiableFields.components.VerificationBox.constants.mobileCode',
    ),
  },
  [BasicField.Email]: {
    logo: EmailOtpSvgr,
    header: i18n.t<string>(
      'features.verifiableFields.components.VerificationBox.constants.verifyEmail',
    ),
    subheader: i18n.t<string>(
      'features.verifiableFields.components.VerificationBox.constants.emailCode',
    ),
  },
}
